module.exports = __webpack_public_path__ + "prod/1.2.3/img/pay-success.0cb8610f.svg";